"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDayLabel = void 0;
const isDateToday_1 = require("./isDateToday");
const isDateYesterday_1 = require("./isDateYesterday");
const getDayLabel = (date) => {
    let dateTitle = '';
    if ((0, isDateToday_1.isDateToday)(date)) {
        dateTitle = 'today';
    }
    else if ((0, isDateYesterday_1.isDateYesterday)(date)) {
        dateTitle = 'yesterday';
    }
    return dateTitle;
};
exports.getDayLabel = getDayLabel;
//# sourceMappingURL=getDayLabel.js.map